import './copperkinghotel/style';
import FormStructure from './copperkinghotel/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js